import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogService } from '../dialogs/dialog.service';
import { ImageManagerDialogComponent } from './manager-dialog/image-manager-dialog.component';
import { FileManagerDialogContentComponent } from './manager-content/file-manager-dialog-content.component';
import { FileManagerCommandComponent } from './manager-command/file-manager-command.component';
import { PreviewComponent } from './file-preview/preview.component';
import { DialogModule } from '../dialogs/dialogs.module';
import { CDFileManagerAPI } from './services/file-manager-api';
import { FileUploaderModule } from './file-uploader/file-uploader.module';
import { FilesListComponent } from './files-list/files-list.component';
import { FilesListService, NewFilesListService } from './files-list/files-list.service';
import { QuotaComponent } from './quota/quota.component';
import { TranslateModule } from '@ngx-translate/core';
import { ImageFileEditorService } from './services/image-file-editor.service';
import { TreeModule } from 'primeng/tree';
import { TreeDragDropService } from 'primeng/api';
import { ContextMenuModule } from 'primeng/contextmenu';
import { FmFoldersTreeComponent } from './fm-folders-tree/fm-folders-tree.component';
import { FileItemComponent } from './file-item/file-item.component';
import { SanitizeUrlPipe } from './pipes/sanitize-url.pipe';
import { ElipsisPipe } from './pipes/elipsis.pipe';
import { DragDropModule } from 'primeng/dragdrop';
import { FileSearchComponent } from './file-search/file-search.component';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';

const components = [
  ImageManagerDialogComponent, FileManagerDialogContentComponent, PreviewComponent, FilesListComponent,
  QuotaComponent, FmFoldersTreeComponent, FileManagerCommandComponent, FileItemComponent,
  FileSearchComponent, UploadProgressComponent
];
const pipes = [SanitizeUrlPipe, ElipsisPipe];

@NgModule({
  imports: [CommonModule, FormsModule, DialogModule, FileUploaderModule, TranslateModule.forChild(), TreeModule, ContextMenuModule, DragDropModule],
  declarations: [...components, ...pipes],
  providers: [DialogService, CDFileManagerAPI, FilesListService, ImageFileEditorService, TreeDragDropService, SanitizeUrlPipe, NewFilesListService],
  entryComponents: [ImageManagerDialogComponent],
  exports: [...components, ...pipes]
})
export class FileManagerModule {
}
